import SectionHeading from '../components/SectionHeading';
import PersonaCard from '../components/PersonaCard';

const personas = [
  {
    emoji: '💑',
    title: 'Couples in Conflict',
    description:
      "You love each other but can't stop the cycle of arguments. Learn to hear each other — even in conflict — and reconnect.",
  },
  {
    emoji: '👨‍👩‍👧‍👦',
    title: 'Parents & Families',
    description:
      'Replace yelling and power struggles with cooperation. Raise emotionally intelligent kids.',
  },
  {
    emoji: '💼',
    title: 'Professionals',
    description:
      'Navigate difficult conversations at work. Lead with empathy, resolve conflict, build trust.',
  },
  {
    emoji: '🌱',
    title: 'Self-Growth Seekers',
    description:
      'Understand your own feelings and needs more deeply. Build better relationships with everyone.',
  },
];

export default function WhoThisIsForSection() {
  return (
    <section id="who-its-for" className="ee-landing-section">
      <div className="ee-landing-container">
        <SectionHeading
          title="Who This Is For"
          subtitle="Whether you're trying to save a relationship or just want to communicate better — you're in the right place."
        />

        <div className="ee-landing-grid ee-landing-grid--4">
          {personas.map((persona, index) => (
            <PersonaCard
              key={persona.title}
              emoji={persona.emoji}
              title={persona.title}
              description={persona.description}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
